// extracted by mini-css-extract-plugin
module.exports = {"top":"_6c97079b1b--top--Qqu1x","close":"_6c97079b1b--close--Vnpu8"};